module.exports = "../static/media/logo.e5823132.png";